<template>

  <div class="">
    <div class="px-3 py-3 d-flex align-items-center">
      <div class="d-flex align-items-center">
        <Render v-if="addNewButton" :render="addNewButton"/>
        <b-form-select :options="limitOptions"
                       value="20"
                       @change="$emit('update-limit', $event)"
                       class=" mr-3"/>
        <b-button :variant="'outline-secondary'"
                  class="mr-3"
                  @click="$emit('reset')">
          <fa icon="sync-alt"/>
        </b-button>
      </div>
      <div class="input-group w-auto mr-2">
        <input class="form-control "
               type="text"
               v-model="$parent.searchKey"
               @keyup.enter="$emit('search')"
               placeholder="Search">
        <span class="input-group-append">
          <b-button :variant="'outline-secondary'"
                    @click="$emit('search')">
            <fa icon="search"/>
          </b-button>
        </span>
      </div>
      <div class="input-group w-auto mr-2" v-if="showChatIdFilter">
        <input class="form-control "
               style="max-width: 110px"
               type="number"
               v-model="$parent.chatId"
               @keyup.enter="$emit('search')"
               placeholder="Chat Id">
        <span class="input-group-append">
          <b-button :variant="'outline-secondary'"
                    @click="$emit('search')">
            <fa icon="search"/>
          </b-button>
        </span>
      </div>
      <div class="d-flex align-items-center">
        <Render v-if="filterButton" :render="filterButton"/>
      </div>
      <div class="d-flex align-items-center">
        <Render v-if="exportButton" :render="exportButton"/>
      </div>
    </div>
  </div>

</template>

<script>

import {library} from '@fortawesome/fontawesome-svg-core'
import {
  faInfoCircle,
  faSearch,
  faSyncAlt,
  faUndoAlt,
  faTimesCircle
} from '@fortawesome/free-solid-svg-icons'

library.add(faSyncAlt, faUndoAlt, faSearch, faInfoCircle, faTimesCircle)

export default {
  name: 'TableHeaderPanel',
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    addNewButton: {
      type: Function
    },
    filterButton: {
      type: Function
    },
    exportButton: {
      type: Function
    },
    showChatIdFilter: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      modal: false,
      button: null,
      limitOptions: [
        {value: 20, text: '20'},
        {value: 30, text: '30'},
        {value: 40, text: '40'},
        {value: 50, text: '50'}
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/listing/TableHeaderPanel.vue